import { throttle } from 'lodash-es';
import chatttSDK from '../chattt';
import { uploadLogFile } from '../api/uploads';
import { scheduleIdle } from 'utils/scheduleIdle';

const logs: string[] = [];
const MAX_LIMIT = 2000;

export const writeLog = (data: string) => {
  if (logs.length >= MAX_LIMIT) {
    logs.shift();
  }
  logs.push(data);

  if (chatttSDK && chatttSDK?.app?.writeNimLog) {
    scheduleIdle(() => {
      chatttSDK?.app?.writeNimLog?.(data);
    });
  }
};

const extraSocketUrl = () => {
  const regex = /socket\s+url:\s+(https?:\/\/[^\s,]+)/g;
  let match = null;
  for (let i = logs.length - 1; i >= 0; i--) {
    const log = logs[i];
    match = regex.exec(log);
    if (match !== null && match?.[1]) {
      return match[1];
    }
  }
};

interface UploadLogFilesOptions {
  accid: string;
  orgId: number;
  userId: number;
}

export const uploadLogFiles = throttle((options: UploadLogFilesOptions) => {
  if (logs.length === 0) return;
  if (chatttSDK && chatttSDK?.app?.uploadNimLog) {
    const socketUrl = extraSocketUrl();
    if (socketUrl) {
      const { accid, userId, orgId } = options;
      const token = sessionStorage.getItem('@fett-token') || localStorage.getItem('@fett-token');
      console.log('socketUrl', socketUrl);
      chatttSDK?.app
        ?.uploadNimLog?.({
          socketUrl,
          token: token ? token : undefined,
          accid,
          userId,
          orgId,
        })
        .then(() => {
          logs.splice(0, logs.length);
          console.log('上传日志文件成功');
        })
        .catch((err: any) => {
          console.error('上传日志文件失败', err);
        });
    }
  } else {
    const blob = new Blob([logs.join('\n')], { type: 'text/plain' });
    const file = new File([blob], 'nim.log', { type: 'text/plain' });
    uploadLogFile(file)
      .then(() => {
        logs.splice(0, logs.length);
        console.log('上传日志文件成功');
      })
      .catch((err: any) => {
        console.error('上传日志文件失败', err);
      });
  }
}, 60 * 1000);
